import React, {useRef} from 'react';
import {View, Text} from 'react-native';
import {useSelector} from 'react-redux';
import {images} from '../../../../assets/icons';
import {Button} from '../../../../shared/components/button';
import {Hr} from '../../../../shared/components/hr';
import {CustomScrollView} from '../../../../shared/components/scrollView';
import {CertificateInfo} from '../../../../shared/models/api/eCertificatesResponsePayload';
import {LoadableContent} from '../../../../shared/components/loadableContent';
import {numberFormatToRub} from '../../../../shared/utils/numberFormatToRub';
import {certifacteDownloadingSelector, sellersSelector} from '../../../../redux/selectors/eCertificates';
import {CertificateTable} from '../CertificateTable';
import {SellersGeoMap} from '../SellersGeoMap';
import {useInfoTabStyles} from './InfoTab.style';

interface InfoTabProps {
  onExportCertificate: () => void;
  certificate?: CertificateInfo | null;
}

export function InfoTab({certificate, onExportCertificate}: InfoTabProps) {
  const styles = useInfoTabStyles();
  const sellers = useSelector(sellersSelector());
  const {templateName, certificateNumber, actualAmount, organizationName, truBalance} = certificate ?? {};
  const mapContainerRef = useRef<View>(null);
  const downloading = useSelector(certifacteDownloadingSelector());

  return (
    <LoadableContent loading={!certificate}>
      <Button
        id='download-ec'
        type='secondary'
        icon={images.Download}
        iconProps={{width: 24, height: 24}}
        iconPosition='left'
        text='Выгрузить ЭС'
        disabled={downloading}
        style={{minWidth: 200, position: 'absolute', right: -5, top: -73, paddingHorizontal: 12}}
        onPress={onExportCertificate}
      />
      <View style={styles.topBlock}>
        <View style={styles.topBlockLeftColumn}>
          <Text style={styles.title}>{templateName}</Text>
          <Text style={styles.regNumber}>Рег. номер: {certificateNumber}</Text>
        </View>

        {certificate && certificate.certificateTypeCode !== 'ECTP0001' && (
          <View style={styles.balanceCard}>
            <Text style={styles.balanceText}>Доступный остаток</Text>
            <Text style={styles.balance}>{numberFormatToRub(actualAmount ?? 0)}</Text>
          </View>
        )}
      </View>

      <CertificateTable certificate={certificate} />

      <Text style={styles.organizationName}>
        Наименование организации, предоставляющей сертификат: {organizationName}
      </Text>

      {truBalance?.length ? (
        <>
          <Text style={styles.subTitle}>Товары/работы/услуги возможные к приобретению по данному сертификату</Text>
          <Hr marginTop={16} marginBottom={16} />

          <CustomScrollView style={{maxHeight: 500}}>
            {truBalance?.map((item) => (
              <>
                <Text key={item.truId} style={styles.truName}>
                  {item.truName}
                </Text>
                <Hr marginTop={16} marginBottom={16} />
              </>
            ))}
          </CustomScrollView>
        </>
      ) : null}

      <View ref={mapContainerRef}>
        <SellersGeoMap sellers={sellers} />
      </View>
    </LoadableContent>
  );
}
